import { PropType, type Component as VueComponent } from 'vue';

import { Component, Prop, Vue } from 'vue-property-decorator';

import { JsonFormType } from '@evidentid/json-schema/interfaces/JsonForm';

import JsonSchemaArrayForm from './elements/JsonSchemaArrayForm.vue';
import JsonSchemaBooleanForm from './elements/JsonSchemaBooleanForm.vue';
import JsonSchemaConstForm from './elements/JsonSchemaConstForm.vue';
import JsonSchemaEnumForm from './elements/JsonSchemaEnumForm.vue';
import JsonSchemaNumberForm from './elements/JsonSchemaNumberForm.vue';
import JsonSchemaObjectForm from './elements/JsonSchemaObjectForm.vue';
import JsonSchemaStringForm from './elements/JsonSchemaStringForm.vue';
import {
    JsonSchemaFormComponentMatchingFunction,
    JsonSchemaFormCustomComponentInput, JsonSchemaFormCustomComponentsMap,
    JsonSchemaFormStrings,
} from './types';

@Component({
    inheritAttrs: false,
})
export default class AbstractJsonSchemaFormElement extends Vue {
    @Prop({ type: Boolean, default: false })
    protected required!: boolean;

    @Prop({ type: Boolean, default: false })
    protected disabled!: boolean;

    @Prop({ type: Boolean, default: false })
    protected touched!: string;

    @Prop({ type: Object, default: () => ({}) })
    protected strings!: Partial<JsonSchemaFormStrings>;

    @Prop({ type: [ Object, Function ] as PropType<JsonSchemaFormCustomComponentInput | null> })
    protected customComponentInput?: JsonSchemaFormCustomComponentInput | null;

    @Prop({ type: Boolean, default: false })
    protected rbacDisabled!: boolean;

    @Prop({ type: Boolean, default: false })
    protected wrapValueMode!: boolean;

    @Prop({ type: String, default: '' })
    protected customTitle!: string;

    @Prop({ type: Boolean, default: true })
    protected showValidationErrors!: boolean;

    protected get getCustomComponent(): JsonSchemaFormComponentMatchingFunction | null {
        return typeof this.customComponentInput === 'function'
            ? this.customComponentInput as JsonSchemaFormComponentMatchingFunction
            : null;
    }

    protected get customComponents(): JsonSchemaFormCustomComponentsMap | null {
        return typeof this.customComponentInput === 'object'
            ? this.customComponentInput as JsonSchemaFormCustomComponentsMap
            : null;
    }

    // PRODUCT-26110 Phase 2B2 Task 5 batch 5: see types.ts's comment on why this uses
    // Vue 3's own `Component` type directly instead of the ambient `Vue.Component`/
    // `Vue.AsyncComponent` namespace (which resolves to Vue 2's real, incompatible
    // 4-generic-param types via a transitive vue@2.7.16 UMD global here).
    protected get components(): Record<JsonFormType, VueComponent> {
        return {
            array: JsonSchemaArrayForm,
            string: JsonSchemaStringForm,
            number: JsonSchemaNumberForm,
            boolean: JsonSchemaBooleanForm,
            const: JsonSchemaConstForm,
            object: JsonSchemaObjectForm,
            enum: JsonSchemaEnumForm,
            ...this.customComponents,
        };
    }
}
